import type { FC } from 'react';
import { ServletWrapper } from './Servlet.styled';

interface ServletProps { }

const Servlet: FC<ServletProps> = () => (
   <ServletWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Servlet</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">Servlet is a robust and scalable technology used to create a web application. It resides at the server-side and generates a dynamic web page. Servlet class extends the capabilities of the servers and responds to the incoming requests. Servlet is an API that provides many interfaces and classes such as Servlet, HttpServlet, ServletRequest, ServletResponse, etc.</p>
         <p  className="text-align-justify">In this section of our training, we will be covering the following topics :</p>
         <ul  className="text-align-justify">
            <li><a href="/working-of-a-servlet">Working of a Servlet</a></li>
            <li><a href="/session-management">Session Management</a></li>
         </ul>
      </div>
   </ServletWrapper>
);

export default Servlet;
